import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const marketAreas = [
    "Food & Beverages", 
    "Real Estate & Townships", 
    "Hospitals & Medical Sector",
    "Construction Projects", 
    "Urban Bodies",
    "Pharmaceuticals", 
    "Cement Industries"
];

const About = () => {
  return (
    <Box 
      id="about" 
      sx={{ 
        py: 10, 
        bgcolor: '#ffffff',
        // --- Background Image Styling ---
        // backgroundImage: 'url(/images/image_2.png)',
        backgroundSize: 'cover',   // Ensures image covers the section. Use 'contain' if you want to see the whole map.
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        // -------------------------------
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          
          <Grid item xs={12} md={5}>
             <Typography variant="overline" color="secondary" fontWeight="bold">Corporate Profile</Typography>
             <Typography variant="h2" gutterBottom sx={{ fontSize: '2.2rem' }}>
                Vision & Capabilities
             </Typography>
             {/* Added a subtle background to text ensures readability if the map image is dark */}
             <Typography paragraph color="text.secondary" sx={{ fontSize: '1rem', lineHeight: 1.8 }}>
                Green & Blue Solutions (Est. 2014) focuses on understanding our clients’ business demands 
                and applying our greatest capabilities to solve complex environmental and water challenges.
             </Typography>
             <Box sx={{ borderLeft: '4px solid #2e7d32', pl: 2, mt: 3 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    "Optimizing capital and operational expenses through sustainable innovation."
                </Typography>
             </Box>
          </Grid>
          
          <Grid item xs={12} md={7}>
            <Paper elevation={0} sx={{ p: 4, bgcolor: '#f8f9fa', borderRadius: 4, border: '1px solid #e0e0e0' }}>
                <Typography variant="h6" color="primary" gutterBottom sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <VerifiedUserIcon sx={{ mr: 1, color: 'secondary.main' }} />
                    Our Market Areas
                </Typography>
                
                <Grid container spacing={2}>
                    {marketAreas.map((area, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <Box sx={{ 
                                display: 'flex', 
                                flexDirection: 'column', 
                                alignItems: 'center', 
                                textAlign: 'center',
                                p: 1,
                                bgcolor: 'white',
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                height: '100%',
                                transition: '0.3s',
                                '&:hover': { transform: 'translateY(-3px)', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }
                            }}>
                                <CheckCircleIcon sx={{ fontSize: 20, color: 'secondary.main', mb: 1 }} />
                                <Typography variant="caption" fontWeight="bold" lineHeight={1.2}>
                                    {area}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;